import { ContactMeetingState } from "../contact/contact.class";

export class AccompainedUser{

  id: string;
  name: string;
  emailaddress?: string;
  businessunitid?: string;
  businessunitname?: string;
  checked?:boolean;
  activityId?:string;
  remoteMeetingJoinStatus?: ContactMeetingState;
  remoteMeetingJoinedDate?;
  remoteMeetingLeftDate?;
  positionId?:string;
  userType?:string[];
  /**
   * indskr_accompanieduser junction-record id. The v2 meeting patch deletes covisitors by this id,
   * not by user id, so a removal cannot be sent without it. Comes down with every bulk-data sync,
   * and from UpdateMeetingResponse.createdUsers for a user added in this session.
   */
  accompaniedUserId?: string;

  constructor(e: IrawAccompainedUser, isFromAppointmentActivity = false){
    this.id = e.userid ? e.userid : e.indskr_user;
    this.accompaniedUserId = e.indskr_accompanieduserid;
    this.name = e.userfullname;
    this.businessunitid = e.businessunitid;
    this.businessunitname = e.businessunitname;
    this.emailaddress = e.emailaddress;
    this.positionId = e.positionId;

    if(e.userType){
      this.userType = e.userType.split(',');
    }
    
    if (isFromAppointmentActivity) {
      this.remoteMeetingJoinStatus = e.indskr_joinstatus;
    }
  }
 
}

export interface IrawAccompainedUser {
  userid: string;
  indskr_user?: string;
  indskr_accompanieduserid?: string;
  userfullname: string;
  businessunitid?: string;
  businessunitname?: string;
  emailaddress?: string;
  activityId?: string;
  indskr_joinstatus?: number;
  positionId?:string;
  userType?:string;
  targetType?: 'user' | 'warehouse';
  warehouseCode?: string;
  warehouseDescription?: string;
}
